import { isDev } from "../../config";
import { endpoints } from "../endpoints";
import { instance } from "../config";
var baseOptions = {
  withCredentials: !isDev
};
export var createCaptcha = function createCaptcha(data) {
  return instance.post(endpoints.captcha.create, data, baseOptions);
};
export var captchaValidate = function captchaValidate(data) {
  return instance.post(endpoints.captcha.validate, data, baseOptions);
};
export var refreshTokenRequest = function refreshTokenRequest() {
  return instance.post(endpoints.captcha.refresh, {}, baseOptions);
};